declare global {
    interface Window {
        env: any;
        $crisp: Array<any>;
        CRISP_WEBSITE_ID: string;
        async: boolean;
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
    }
}

// Update: localhost api to the current hosted development server api's
export type EnvType = {
    REACT_APP_SPAY_TEST_SERVER: string;
    REACT_APP_SPAY_PROD_SERVER: string;

    REACT_APP_SPAY_TEST_COLLECTIONS: string;
    REACT_APP_SPAY_PROD_COLLECTIONS: string;

    REACT_APP_SPAY_PAYMENT_PAGE_TITLE: string;
    REACT_APP_SPAY_TEST_PAYMENT_PAGE: string;
    REACT_APP_SPAY_PROD_PAYMENT_PAGE: string;

    REACT_APP_SPAY_TEST_SETTLEMENT: string;
    REACT_APP_SPAY_PROD_SETTLEMENT: string;

    REACT_APP_SETTLEMENT_TAG: string;
    REACT_APP_SPAY_SETTLEMENT_CD: string;
    REACT_APP_INTERNAL_STORAGE_ID: string;

    REACT_APP_CLIENT_ID?: string;
    REACT_APP_CLIENT_SECRET?: string;
};

export const env: EnvType = {
    ...window.env,
    ...process.env,
    REACT_APP_INTERNAL_STORAGE_ID: process.env.REACT_APP_INTERNAL_STORAGE_ID || window.env?.REACT_APP_INTERNAL_STORAGE_ID
};
